import { ColumnSummaryDescriptionCollection as ColumnSummaryDescriptionCollection_internal } from "./ColumnSummaryDescriptionCollection";
var IgrColumnSummaryDescriptionCollection = /** @class */ /*@__PURE__*/ (function () {
    function IgrColumnSummaryDescriptionCollection() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    }
    IgrColumnSummaryDescriptionCollection.prototype.createImplementation = function () {
        return new ColumnSummaryDescriptionCollection_internal();
    };
    Object.defineProperty(IgrColumnSummaryDescriptionCollection.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrColumnSummaryDescriptionCollection.prototype.onImplementationCreated = function () {
    };
    IgrColumnSummaryDescriptionCollection.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    IgrColumnSummaryDescriptionCollection.prototype.add = function (item) {
        var iv = this.i.g((item == null ? null : item.i));
        return (iv);
    };
    IgrColumnSummaryDescriptionCollection.prototype.insert = function (index, item) {
        this.i.n(index, (item == null ? null : item.i));
    };
    IgrColumnSummaryDescriptionCollection.prototype.clear = function () {
        this.i.m();
    };
    IgrColumnSummaryDescriptionCollection.prototype.indexOf = function (item) {
        var iv = this.i.j((item == null ? null : item.i));
        return (iv);
    };
    IgrColumnSummaryDescriptionCollection.prototype.remove = function (item) {
        var iv = this.i.h((item == null ? null : item.i));
        return (iv);
    };
    IgrColumnSummaryDescriptionCollection.prototype.removeAt = function (index) {
        var iv = this.i.d(index);
        return (iv == null ? null : iv.externalObject);
    };
    return IgrColumnSummaryDescriptionCollection;
}());
export { IgrColumnSummaryDescriptionCollection };
//# sourceMappingURL=igr-column-summary-description-collection.js.map
